"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieRoutes = exports.cookieNoticePath = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_1 = require("react-router");
const pageLoader_1 = __importDefault(require("../loaders/pageLoader"));
const CookieNotice = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/cookies/cookieNotice'))));
const ErrorPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/errorPage'))));
const IS_AMEX_PROVIDER = globalThis.IS_PLAYWRIGHT_RUNNING
    ? globalThis.PLAYWRIGHT_CARD_PROVIDER === 'AMEX'
    : globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP;
exports.cookieNoticePath = '/cookie-notice';
exports.cookieRoutes = {
    path: exports.cookieNoticePath,
    element: (0, jsx_runtime_1.jsx)(react_router_1.Outlet, {}),
    children: [
        {
            index: true,
            element: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: IS_AMEX_PROVIDER ? (0, jsx_runtime_1.jsx)(ErrorPage, {}) : (0, jsx_runtime_1.jsx)(CookieNotice, {}) }),
        },
    ],
};
